"use client";

import { buttonVariants } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { GetLomdaV2ResponseType } from "../../hooks/useGetLomdaV2";
import { Label } from "@/components/ui/label";
import DeleteLomdaV2Button from "./deleteButton";
import DuplicateLomdaV2Button from "./duplicateButton";
import { useStorage } from "@/features/storage/useStorage";
import { t } from "@/lib/localization";

export default function LomdaV2SheetHeader({
    lomda,
}: {
    lomda: GetLomdaV2ResponseType["data"];
}) {
    const setOpen = useStorage((state) => state.setLomdaV2SheetOpen);

    return (
        <header className="bg-white px-8 flex flex-row h-16 w-full justify-between items-center border-b">
            <div className="truncate flex flex-col">
                <Label className="truncate text-base">
                    {lomda?.name
                        ? t("lomda-sheet.header.title", undefined, { lomdaName: lomda.name })
                        : t("lomda-sheet.header.title.placeholder", undefined, undefined)}
                </Label>

                {!!lomda?.folders?.length && (
                    <p
                        className="truncate text-xs text-muted-foreground"
                        title={lomda.folders?.map((f) => f.name).join(", ")}
                    >
                        {t("lomda-sheet.header.folders", undefined, {
                                folderNames:
                                    lomda.folders
                                        ?.map((f) => f.name)
                                        .join(", ") || "",
                            })}
                    </p>
                )}
            </div>

            <div className="hidden md:flex flex-row gap-2">
                <a
                    onClick={() => {
                        setOpen(false);
                    }}
                    href={`/lomda/${lomda.id}`}
                    className={buttonVariants({
                        variant: "secondary",
                        size: "sm",
                    })}
                >
                    <Pencil className="size-3.5 me-2" />
                    {t("lomda-sheet.header.edit-btn", undefined, undefined)}
                </a>
                <DuplicateLomdaV2Button lomda={lomda} />
                <DeleteLomdaV2Button lomda={lomda} />
            </div>
        </header>
    );
}
